
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#323334"}},[_c('path',{attrs:{"d":"M0 1.55V.42C0 .2.19 0 .42 0h15.01c.24 0 .43.19.43.42v1.13c0 .24-.2.43-.43.43h-15A.42.42 0 010 1.55zm.57 13.99h15c.24 0 .43-.2.43-.43v-1.13a.42.42 0 00-.42-.42H.57a.42.42 0 00-.43.42v1.13c0 .24.2.43.43.43z"}}),_c('rect',{attrs:{"stroke":"#323334","x":"3.5","y":"5.5","width":"9","height":"4.49","rx":"1"}})])])
          )
        }
      }
    